export class DtoBase {
}
